export class GetAllRolesDropDown {
    rolesName: string;
    rolesId: number;
    constructor(
        rolesName: string,
        rolesId: number
    ) {
        this.rolesName = rolesName;
        this.rolesId = rolesId;
    }
}